import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
// import Link from "@material-ui/core/Link";

const styles = {
  para: {
    fontSize: 16
  },
  imgdiv: {
    textAlign: "center",
    margin: "10px"
  },
  img: {
    borderRadius: "8px",
    border: "1px solid gray",
    width: "80%"
  }
};

const assembly = props => {
  const { classes } = props;
  return (
    <div>
      <Typography variant="h4">Soldering Station</Typography>
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./fabisp/assembly00.jpg"
          alt="tinyisp"
        />
      </div>
      <Typography variant="h4">Components</Typography>
      <Typography className={classes.para} paragraph>
        The components required for the assembly are follows as per tutorial
        given by Mr Brian is,
        <ul>
          <li>1x ATtiny45 or ATtiny85</li>
          <li>2x 1kΩ resistors</li>
          <li>2x 499Ω resistors</li>
          <li>2x 49Ω resistors</li>
          <li>2x 3.3v zener diodes</li>
          <li>1x red LED</li>
          <li>1x green LED</li>
          <li>1x 100nF capacitor</li>
          <li>1x 2x3 pin header</li>
        </ul>
      </Typography>
      <Typography variant="h4">Assembled PCB</Typography>
      <div className={classes.imgdiv}>
        <img
          className={classes.img}
          src="./fabisp/finalpcb.jpg"
          alt="tinyisp"
        />
      </div>
      I've used flexible copper strip at places where there was delamination of
      circuit due to overheating. Particularly over heating is probable at USB
      slot.
      <div className={classes.imgdiv}>
        <img className={classes.img} src="./fabisp/delam.jpg" alt="tinyisp" />
      </div>
      <Typography variant="h4">Continuity/ Component Check</Typography>
      <Typography className={classes.para} paragraph>
        <div className={classes.imgdiv}>
          <img
            className={classes.img}
            src="./fabisp/conti-check.jpg"
            alt="tinyisp"
          />
        </div>
      </Typography>
      <ul>
        <li>
          <Typography className={classes.para} paragraph>
            Check LED: To check LED biasing put the multimeter in 'Diode' mode
            and see if the a voltage is seen and LED glows faintly.
          </Typography>
        </li>
      </ul>
    </div>
  );
};

export default withStyles(styles)(assembly);
